const structure = {

	report: [
		{
			text : {
				en: "REALTOR.ca Highlights",
				fr: "Données&nbsp;sur REALTOR.ca"
			},
			jump: '#insights',
			subnav: [
				{
					text : {
						en: "2021 By the Numbers",
						fr: "2021 en chiffres"
					},
					jump: '#bythenumbers',
					subnav: false,
				},
			],
		},
		{
			text: {
				en: "Consumer Highlights",
				fr: "Données sur les consommateurs"
			},
			jump: '#consumer',
			subnav: [
				{
					text : {
						en: "How Visitors Arrive at REALTOR.ca",
						fr: "Comment les visiteurs se rendent-ils sur REALTOR.ca?"
					},
					jump: '#visitors',
					subnav: false,
				},
				{
					text : {
						en: "Visits to REALTOR.ca",
						fr: "Visites sur REALTOR.ca"
					},
					jump: '#trafficsources',
					subnav: false,
				},
				{
					text : {
						en: "Visitor Breakdown",
						fr: "Répartition des visiteurs"
					},
					jump: '#visitorbreakdown',
					subnav: false,
				},
				{
					text : {
						en: "Visitors and Views",
						fr: "Visiteurs et pages consultées"
					},
					jump: '#visitorviews',
					subnav: false,
				},
				{
					text : {
						en: "Turning Visitors into Leads",
						fr: "De visiteurs à clients potentiels"
					},
					jump: '#visitorleads',
					subnav: false,
				},
			],
		},
		{
			text : {
				en: "Behavioural Insights",
				fr: "Données comportementales"
			},
			jump: '#behavioural',
			subnav: [
				{
					text : {
						en: "Home Buying Stages",
						fr: "Étapes du processus d’achat d’une propriété"
					},
					jump: '#homebuying',
					subnav: false,
				},
				{
					text: {
						en: "COVID-19 Pandemic Impact",
						fr: "Incidence de la pandémie de la COVID-19"
					},
					jump: '#covidimpact',
					subnav: false,
				},
				{
					text : {
						en: "REALTOR.ca Account Holders",
						fr: "Comptes d’utilisateurs sur REALTOR.ca"
					},
					jump: '#websiteusage',
					subnav: false,
				},
				{
					text : {
						en: "Time Using REALTOR.ca",
						fr: "Temps passé sur REALTOR.ca"
					},
					jump: '#timeonsite',
					subnav: false,
				},
				{
					text : {
						en: "Devices Used",
						fr: "Appareil utilisé"
					},
					jump: '#devicesused',
					subnav: false,
				},
				{
					text: {
						en: "International",
						fr: "Visiteurs internationaux"
					},
					jump: '#international',
					subnav: false,
				},
			],
		},
	],

	local: [
		{
			text : {
				en: "Search Behaviour",
				fr: "Comportement de recherche"
			},
			jump: '#searchtrends',
			subnav: [
				{
					text : {
						en: "Top Search Filters",
						fr: "Filtres de recherche les plus utilisés"
					},
					jump: '#topsearchfilters',
					subnav: false,
				},
				{
					text : {
						en: "Top Search Terms",
						fr: "Mots-clés les plus recherchés"
					},
					jump: '#topsearchterms',
					subnav: false,
				},
				{
					text: {
						en: "Neighourhoods or listings visited",
						fr: ""
					},
					jump: '#neighbourhoods',
					subnav: false,
				},
				{
					text: {
						en: "Interprovincial listing seraches",
						fr: ""
					},
					jump: '#provinces',
					subnav: false,
				},								
				// {
				// 	text : {
				// 		en: "Top Neighbourhoods Viewed",
				// 		fr: "Quartiers les plus consultés"
				// 	},
				// 	jump: '#topneighbourhoods',
				// 	subnav: false,
				// },
			],
		},
		{
			text : {
				en: "Demographics",
				fr: "Données démographiques"
			},
			jump: '#demographics',
			subnav: false,
		},
		{
			text: {
				en: "Usage Behaviour",
				fr: "Comportement d’utilisation"
			},
			jump: '#usagetrends',
			subnav: [
				{
					text : {
						en: "Device Breakdown",
						fr: "Type d’appareil"
					},
					jump: '#devicebreakdown',
					subnav: false,
				},
				{
					text : {
						en: "Social Sharing",
						fr: "Partage sur les réseaux sociaux"
					},
					jump: '#socialsharing',
					subnav: false,
				},
			],
		},
	],

}

export default {
  structure,
}